module.exports = __webpack_public_path__ + "static/CO-61ef9a8a9d0ad74429f36b7ae0a1bdf1.svg";